import React from "react";

export default function ProjectBox({ img, title, text, action}) {
  return (
    <div className="w-full mt-6">
      <button className="p-0 m-0 bg-transparent border-0 outline-none block group" onClick={action ? () => action() : null}>
        <img className="rounded-lg w-full h-auto my-5 transition-opacity duration-200 group-hover:opacity-50" src={img} alt="project" />
      </button>
      <h3 className="text-xl font-extrabold pb-2">{title}</h3>
      <p className="text-base font-extrabold">{text}</p>
    </div>
  );
}
